import * as types from "../actions/actionTypes";
const INITIALIZED_NOTIFICATIONS = {
  pending_projects: [],
  tickets: [],
  announcements: [],
  promo_codes: [],
  notifications: { data: [], meta: {} }
};
const INITIALIZED_NOTIFICATIONS_COUNT = {
  ticket: 0,
  general: 0,
  announcement: 0,
  promo_code: 0,
  pending_project: 0
};
const initialState = {
  loading: true,
  error: "",
  list: INITIALIZED_NOTIFICATIONS,
  count: 0,
  notificationCountsObject: INITIALIZED_NOTIFICATIONS_COUNT,
  readProcessing: {},
  isSeen: {},

  removeProcessing: {},
  removedId: null
};

const Notification = (state = initialState, action) => {
  let readProcessing = { ...state.readProcessing };
  let seen = { ...state.isSeen };

  let removeProcessing = { ...state.removeProcessing };
  switch (action.type) {
    case types.NOTICE_READ_REQUEST:
      readProcessing[action.id] = true;
      return { ...state, readProcessing: readProcessing };
    case types.NOTICE_READ_SUCCESS:
      readProcessing[action.id] = false;
      seen[action.id] = action.isSeen;
      return { ...state, readProcessing: readProcessing, isSeen: seen };
    case types.NOTICE_READ_FAILURE:
      readProcessing[action.id] = false;
      seen[action.id] = action.isSeen;
      return { ...state, readProcessing: readProcessing, isSeen: seen };

    case types.NOTICE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        list: action.pageNumber ? state.list : INITIALIZED_NOTIFICATIONS
      };
    case types.NOTICE_LIST_SUCCESS:
      return { ...state, loading: false, list: action.payLoad };
    case types.NOTICE_LIST_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.SET_NOTIFICATION_COUNT:
      let countObject = {
        ...state.notificationCountsObject,
        ...action.payLoad
      };
      let count = 0;
      for (const [_, value] of Object.entries(countObject)) {
        count += value;
      }
      return { ...state, notificationCountsObject: countObject, count };

    case types.NOTIFICATION_REMOVE_REQUEST:
      removeProcessing[action.id] = true;
      return { ...state, removeProcessing: removeProcessing, removedId: null };
    case types.NOTIFICATION_REMOVE_SUCCESS:
      removeProcessing[action.id] = false;
      return {
        ...state,
        removeProcessing: removeProcessing,
        removedId: action.id
      };
    case types.NOTIFICATION_REMOVE_FAILURE:
      removeProcessing[action.id] = false;
      return { ...state, removeProcessing: removeProcessing };
    default:
      return state;
  }
};

export default Notification;
